module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tplheader'), _vm._v(" "), _c('tplLeftPanel'), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "fixed-top-menu-outer",
    attrs: {
      "id": "fixed-top-menu-outer"
    }
  }, [_c('div', {
    staticClass: "fixed-top-menu"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ment
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("mentés")])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-panel",
    attrs: {
      "id": "main-panel"
    }
  }, [_c('div', {
    staticClass: "content-panel"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content-panel-top-btn-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ment
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("mentés")])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "id": "mezo1",
      "label": "Mező1",
      "errors": _vm.errors,
      "name": "mezo1"
    },
    model: {
      value: (_vm.form.mezo1),
      callback: function($$v) {
        _vm.$set(_vm.form, "mezo1", $$v)
      },
      expression: "form.mezo1"
    }
  }), _vm._v(" "), _c('combobox', {
    attrs: {
      "id": "mezo2",
      "label": "Mező2",
      "errors": _vm.errors,
      "name": "mezo2"
    },
    model: {
      value: (_vm.form.mezo2),
      callback: function($$v) {
        _vm.$set(_vm.form, "mezo2", $$v)
      },
      expression: "form.mezo2"
    }
  }), _vm._v(" "), _c('checkbox', {
    attrs: {
      "id": "mezo3",
      "label": "Mező3",
      "errors": _vm.errors,
      "name": "mezo3"
    },
    model: {
      value: (_vm.form.mezo3),
      callback: function($$v) {
        _vm.$set(_vm.form, "mezo3", $$v)
      },
      expression: "form.mezo3"
    }
  }), _vm._v(" "), _c('toggle', {
    attrs: {
      "id": "mezo4",
      "label": "Mező4",
      "errors": _vm.errors,
      "name": "mezo4"
    },
    model: {
      value: (_vm.form.mezo4),
      callback: function($$v) {
        _vm.$set(_vm.form, "mezo4", $$v)
      },
      expression: "form.mezo4"
    }
  }), _vm._v(" "), _c('checkboxes', {
    attrs: {
      "id": "mezo5",
      "label": "Mező5",
      "errors": _vm.errors,
      "name": "mezo5"
    },
    model: {
      value: (_vm.form.mezo5),
      callback: function($$v) {
        _vm.$set(_vm.form, "mezo5", $$v)
      },
      expression: "form.mezo5"
    }
  }), _vm._v(" "), _c('radios', {
    attrs: {
      "id": "mezo6",
      "label": "Mező6",
      "errors": _vm.errors,
      "name": "mezo6"
    },
    model: {
      value: (_vm.form.mezo6),
      callback: function($$v) {
        _vm.$set(_vm.form, "mezo6", $$v)
      },
      expression: "form.mezo6"
    }
  }), _vm._v(" "), _c('select2', {
    attrs: {
      "multi": "true",
      "id": "mezo7",
      "label": "Mező7",
      "errors": _vm.errors,
      "name": "mezo7"
    },
    model: {
      value: (_vm.form.mezo7),
      callback: function($$v) {
        _vm.$set(_vm.form, "mezo7", $$v)
      },
      expression: "form.mezo7"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.adminok), function(admin) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(admin.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(admin.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(admin.email))]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "icon-list"
    }, [_c('li', {
      staticClass: "dropdown"
    }, [_vm._m(4, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu"
    }, [_c('li', {
      staticClass: "dropdown-header"
    }, [_vm._v("Opciók")]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.szerkeszt(admin.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    }), _vm._v("Szerkeszt")])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.torol(admin.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v("Töröl")])])])])])])])
  }), 0)])], 1)])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_vm._v("Kezdőőoldal")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "active",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Teszt")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")]), _vm._v("Teszt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Teszt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Név")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f09b0e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/test.vue
// module id = 50
// module chunks = 0